const configJson = require(`../../apps/${process.env.APP_NAME}/app.config.json`)

export const APP_CONFIG = configJson

export default APP_CONFIG